import React from 'react';
import PropTypes from 'prop-types';
import {
  Columns,
  Column,
  IconWrapper,
  Icon,
  IconTitle,
  IconBody,
  IconsWrapper
} from './Icons.style';
import {CommonTitle, CommonSubTitle, CommonContent} from './LightHomePage.style';
import {getIcons} from './IconSwitch';

export const Icons = props => {

  const {block, isDeliveryMode} = props;
  const renderSubTitle = block.subtitle && <CommonSubTitle>{block.subtitle}</CommonSubTitle>;
  const renderColumns = block.columns && block.columns.map((column, i) => (
    <Column key={column.title + i}>
      <IconWrapper>
        <Icon>{getIcons(i, isDeliveryMode)}</Icon>
      </IconWrapper>
      <IconTitle>{column.title}</IconTitle>
      <IconBody>{column.body}</IconBody>
    </Column>
  ));
  return (
    <IconsWrapper
      name={block.navigationTitle}
      id={block.navigationTitle}
    >
      <CommonContent>
        <CommonTitle>{block.title}</CommonTitle>
        {renderSubTitle}
        <Columns>{renderColumns}</Columns>
      </CommonContent>
    </IconsWrapper>
  );
};

Icons.propTypes = {
  block: PropTypes.object.isRequired,
  isDeliveryMode: PropTypes.bool.isRequired
};



// WEBPACK FOOTER //
// ./containers/LightHomePage/Icons.js